import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  column-gap: 12px;
  margin-bottom: 6px;
  align-items: center;
`;

export const BackButton = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #f0f3f6;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: #f2f4f6;
  }
`;
